import { URL_CONFIG } from '~~/shared/utils/url.const.js'

export type BlogType = 'article' | 'video' | 'podcast'

export interface ParsedBlog {
  urlKey: string
  title: string
  metaTitle: string | null
  url: string
  mediaUrl: string | null
  caption: string | null
  publishDate: string | null
  author: { name: string }
  videoId: string | null
  podcastUrl: string | null
  content: string | null
  transcript?: string | null
  rundown:string | null,
  rundownTitle : string | null
  tags?:any[]
}

export interface RawBlogItem {
  urlKey?: string
  name?: string
  title?: string
  publishAt?: string
  media?: {
    medFile?: string
    medFilename?: string
  }
  metaData?: {
    metaTitle?: string
  }
  cau?: {
    value?: {
      name?: string
    }
  }
  author?: {
    name?: string
  }
  caption?: string
  description?: string
  content?: string
  videoId?: string
  youtubeId?: string
  transcript?: string
  thumbnailUrl?: string
  podcastUrl?: string
  audioLink?: string
  hasTags?: boolean
  rundown:string 
  rundownTitle : string 
  tags?: any[]
  taggings? :any[]
}

export const blogDetailsValue = (
  item: RawBlogItem,
  blogType: BlogType
): ParsedBlog => {
  if (!item) {
    throw new Error('blogDetailsValue: item is required')
  }
  const defaultImage = new URL('@/assets/images/default-podcast.png', import.meta.url).href;

  const base = {
    urlKey: item.urlKey || '',
    title: item.name || item.title || '',
    metaTitle: item.metaData?.metaTitle || null,
    url: `${URL_CONFIG.TAKE_5_DAILY}/${blogType}/${item.urlKey}`,
    publishDate: item.publishAt
      ? item.publishAt
      : null,
    author: {
      name: item.cau?.value?.name || item.author?.name || 'Unknown'
    }
  }

  switch (blogType) {
    case 'article':
      return {
        ...base,
        mediaUrl: item.media?.medFile || null,
        caption: item.metaData?.metaTitle || null,
        content: item.content || '',
        videoId: null,
        podcastUrl: null,
        transcript: null,
        rundown:  null,
        rundownTitle: null,
        tags: item?.taggings || [],
      }

    case 'video':
      return {
        ...base,
        mediaUrl: item.media?.medFilename || null,
        caption: item.caption || null,
        videoId: item.videoId || item.youtubeId || null,
        podcastUrl: null,
        content: item.description || item.content || null,
        transcript: item.transcript || null,
        rundown:  null,
        rundownTitle: null
      }

    case 'podcast':
      return {
        ...base,
        mediaUrl: item.media?.medFile || defaultImage,
        caption: item.caption || null,
        podcastUrl: item.audioLink || null,
        videoId: null,
        content: item.description || item.content || null,
        transcript: item.transcript || null,
        rundown: item.rundown ||  null,
        rundownTitle: item.rundownTitle || null
      }

    default:
      throw showError({ statusCode: 404, statusMessage: "Page Not Found" });
  }
}

export const keepReadingTags = (taggings: any[] = []) => {
  if (!taggings) return []

  return taggings.map(tag => ({
    label: tag?.tag || 'Tag',
    query: tag?.tag || '#'
  }))
}
